import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertCircle, AlertTriangle, CheckCircle2, ChevronDown, Info } from "lucide-react";
import { useState } from "react";
const variantStyles = {
    info: {
        box: "border-primary/20 bg-primary-soft",
        title: "text-primary-soft-fg",
        icon: _jsx(Info, { size: 16 }),
    },
    success: {
        box: "border-success/20 bg-success-soft",
        title: "text-success",
        icon: _jsx(CheckCircle2, { size: 16 }),
    },
    warning: {
        box: "border-warning/30 bg-warning-soft",
        title: "text-warning",
        icon: _jsx(AlertTriangle, { size: 16 }),
    },
    danger: {
        box: "border-danger/20 bg-danger-soft",
        title: "text-danger",
        icon: _jsx(AlertCircle, { size: 16 }),
    },
};
/**
 * A tokenized callout/notice box — the standard "what is this page" banner and
 * inline notices. Replaces hand-rolled palette-colored notice cards and the
 * bespoke admin-shell PageHelp markup. All colors resolve to operator-theme tokens.
 */
export function InfoBanner({ variant = "info", title, children, collapsible = false, defaultOpen = false, icon, className = "", }) {
    const [open, setOpen] = useState(defaultOpen);
    const s = variantStyles[variant];
    const hasBody = children != null;
    const showBody = hasBody && (!collapsible || open);
    const header = (_jsxs("span", { className: `flex items-center gap-2 text-sm font-medium ${s.title}`, children: [_jsx("span", { className: "shrink-0", children: icon ?? s.icon }), title] }));
    return (_jsxs("div", { className: `rounded-lg border ${s.box} ${className}`.trim(), children: [collapsible && hasBody ? (_jsxs("button", { type: "button", onClick: () => setOpen((o) => !o), className: "flex w-full items-center justify-between px-4 py-2.5 text-left", children: [header, _jsx(ChevronDown, { size: 16, className: `shrink-0 ${s.title} transition-transform ${open ? "rotate-180" : ""}` })] })) : (_jsx("div", { className: "px-4 py-2.5", children: header })), showBody && (_jsx("div", { className: `px-4 py-2.5 text-xs ${s.title} ${collapsible ? "border-t border-current/10" : "pt-0"}`, children: children }))] }));
}
//# sourceMappingURL=InfoBanner.js.map